import { lazy } from "react";
import Loadable from "components/Loadable";
import { commonRoutesConstants, routeConstants } from "services/keyConstants";
import * as url from "./urlHelper";
import CommonYearList from "components/reusables/CommonYearList";

// Define lazy-loaded components
const CorrectiveAction = Loadable(lazy(() => import("../CorrectiveAction")));
const PreventiveAction = Loadable(lazy(() => import("../PreventiveAction")));
const CAPAList = Loadable(lazy(() => import("../CapaList")));
const CAPAById = Loadable(lazy(() => import("../CAPAById")));
const YearList = Loadable(lazy(() => import("../YearList")));
const List = Loadable(lazy(() => import("../List")));
const CorrectiveActionList = Loadable(
  lazy(() => import("../CorrectiveActionList"))
);
const PreventiveActionList = Loadable(
  lazy(() => import("../PreventiveActionList"))
);

const getByType = (type) => {
  if (type === "CorrectiveAction") {
    return {
      uri: url.GET_BY_YEAR,
      createRoute: { path: `/capa/corrective/` },
      navigateToFolder: `/capa/corrective-action-list/`,
    };
  } else if (type === "PreventiveAction") {
    return {
      uri: url.GET_BY_YEAR_PREVENTIVE_ACTION,
      createRoute: { path: `/capa/preventive` },
      navigateToFolder: `/capa/preventive-action-list/`,
    };
  }
};

// Define routes using lazy-loaded components
const CAPARoutes = [
  {
    path: routeConstants.CAPA,
    children: [
      { path: "corrective", element: <CorrectiveAction /> },
      { path: "preventive", element: <PreventiveAction /> },
      { path: "corrective-action-list", element: <CorrectiveActionList /> },
      { path: "preventive-action-list", element: <PreventiveActionList /> },
      { path: "list/:id", element: <List /> },
      { path: "capa", element: <CAPAList /> },
      { path: "capadetails", element: <CAPAById /> },
      {
        path: commonRoutesConstants.YEAR_LIST + `/:type`,
        element: (
          <CommonYearList
            title="Corrective & Preventive Action"
            isCreate={true}
            getByType={getByType}
          />
        ),
      },
    ],
  },
];

export default CAPARoutes;
